/**
 * Created by Alexander Golovnya on 2019-05-04.
 */
export function isActivated(value) {
  return value ? "Да" : "Нет";
}
